import Stack from '@mui/material/Stack';
import type { RichContent } from '@openx/components-core/lib/AiChat/types';
import { ActionButton } from './ActionButton';
import { getRichContentActionKey, type RichContentActionEvent } from './utils/richContent';

type RichContentActionsProps = {
  content: RichContent;
  contentKey: string;
  disabled: boolean;
  confirmedActionKeys?: ReadonlySet<string> | undefined;
  onAction?: ((event: RichContentActionEvent) => void) | undefined;
};

export const RichContentActions = ({
  content,
  contentKey,
  disabled,
  confirmedActionKeys,
  onAction,
}: RichContentActionsProps) => {
  if (!content.actions?.length) return null;

  return (
    <Stack
      data-test="rich-content-actions"
      data-state={disabled ? 'disabled' : 'active'}
      sx={{ gap: 1.5, width: '100%' }}
    >
      {content.actions.map(action => {
        const actionKey = getRichContentActionKey(contentKey, action.id);

        return (
          <ActionButton
            key={action.id}
            label={action.label}
            isConfirmed={!!(action.isConfirmed || confirmedActionKeys?.has(actionKey))}
            disabled={disabled}
            onClick={() => {
              onAction?.({ actionKey, action, content, contentKey });
            }}
          />
        );
      })}
    </Stack>
  );
};
